/**
* @file 产品功能
* @author
*/

import React from 'react';
import authMoreVideo from './imgs/auth_more_video.png';
import authMoreCustomer from './imgs/auth_more_customer.png';
import authMoreWeb from './imgs/auth_more_web.png';
import authMoreWx from './imgs/auth_more_wx.png';
import authMoreWb from './imgs/auth_more_wb.png';
import authMoreQa from './imgs/auth_more_qa.png';
import preAuth from './imgs/auth_pre.png';
import aftAuth from './imgs/auth_after.png';
import AuthButton from './authButton';
import ZTag from '../../components/Tag/index';

interface Props {
    title: string;
}
export default function Features(props: Props) {
    const data = [{
        title: '宣传视频',
        img: authMoreVideo
    },
    {
        title: '智能客服',
        img: authMoreCustomer
    },
    {
        title: '官方网站',
        img: authMoreWeb
    },
    {
        title: '官方微信',
        img: authMoreWx
    },
    {
        title: '官方微博',
        img: authMoreWb
    },
    {
        title: '企业问答',
        img: authMoreQa
    },];
    return (
        <div className="features">
            <p className="common-title title">{props.title}</p>
            <p className="common-subtitle">在百度搜索企业名称加客服等关键字后，展示专属卡片</p>
            <div className="features-content">
                <div className="features-auth-box features-auth-pre">
                    <p>认证前</p>
                    <img width="280" src={preAuth}/>
                    <br/>
                    <ZTag color="error" style={{marginRight: '12px'}}>虚假信息</ZTag>
                    <ZTag color="error">错误号码</ZTag>
                </div>
                <span className="features-vs">vs</span>
                <div className="features-auth-box features-auth-after">
                    <p>认证后</p>
                    <img width="544" src={aftAuth}/>
                    <br/>
                    <ZTag color="success" style={{marginRight: '12px'}}>官方信息</ZTag>
                    <ZTag color="success">准确号码</ZTag>
                </div>
            </div>
            <div className="features-more">
                <p  className="features-more-title">点击认证后的号码卡片，展示更多信息</p>
                <div className="features-more-info">
                    {
                        data.map((item, index) => {
                            return (<div
                                className="card-item"
                                key={item.title + index}
                            >
                                <img className="card-item-img" src={item.img}/>
                                <h2>{item.title}</h2>
                            </div>);
                        })
                    }
                </div>
            </div>
            <AuthButton {...props} name="了解更多功能"/>
        </div>
    );
}
